<template>
    <div :class="showBlock?'goTop':''" ref="fr_bel">
        <div class="pay nameBox">
            <span class="payid">{{ detailsObj.pnidMessage }}</span>
            <div class="pay-ipt-box">
                <input class="pay-ipt" :class="fullNameError?'errBorder':''" 
                v-model="fullName" 
                :placeholder="detailsObj.pnidTip" 
                @focus="showBlockBottom"
                @blur="validateName(1);hideBlockBottom"/>
            </div>
            <span class="errtxt" v-if="fullNameError">{{ fullNameError }}</span>
        </div>
        <!-- 银行 -->
        <div class="pay gPayLabel" v-if="itemId == 15">
            <span class="payid">{{ detailsObj.bank }}</span>
            <div class="selectInput activeSelect pay-ipt" @click="changeMenuFlag(1)">{{ bankName }} <i></i></div>
            <div class="downMenu" v-if="menuFlag == 1" @click="changeMenuFlag(0)">
              <div class="searchBank" @click.stop>
                <input type="text" v-model="banName" :placeholder="detailsObj.bankTips"  @click.stop/>
              </div>
              <p v-for="item in filteredBankList" :key="item.code" @click="changeBank(item)">{{ item.name }}</p>
              <p style="text-align: center" v-if="filteredBankList && filteredBankList.length == 0">{{  $t('not_exist') }}</p>
            </div>
        </div>
        <div class="pay"  v-if="itemId == 15">
            <span class="payid">{{ detailsObj.bankCardNumber }}</span>
            <input class="pay-ipt" 
            :class="cardNumberError?'errBorder':''" 
            v-model="cardNumber" 
            :placeholder="detailsObj.bankCardNumber" 
            @focus="showBlockBottom"
            @blur="validateRib();hideBlockBottom()"/>
            <span class="errtxt" v-if="cardNumberError">{{ cardNumberError }}</span>
        </div>
        <!-- e-wallet银行 -->
        <div class="pay gPayLabel" v-if="itemId == 16">
            <span class="payid">{{ detailsObj.bank }}</span>
            <div class="selectInput activeSelect pay-ipt" @click="changeMenuFlag(1)">{{ bankName }} <i></i></div>
            <div class="downMenu" v-if="menuFlag == 1" @click="changeMenuFlag(0)">
              <div class="searchBank" @click.stop>
                <input type="text" v-model="banName" :placeholder="detailsObj.bankTips"  @click.stop/>
              </div>
              <p v-for="item in filteredBankList" :key="item.code" @click="changeBank(item)">{{ item.name }}</p>
              <p style="text-align: center" v-if="filteredBankList && filteredBankList.length == 0">{{  $t('not_exist') }}</p>
            </div>
        </div>
        <!-- e-wallet时展示 -->
        <div class="pay"  v-if="itemId == 16">
            <span class="payid">{{ detailsObj.bankCardNumber }}</span>
            <input class="pay-ipt" 
            :class="phoneNumberError?'errBorder':''" 
            v-model="phoneNumber" 
            :placeholder="detailsObj.bankCardNumber" 
            @focus="showBlockBottom"
            @blur="validatePhoneNumber();hideBlockBottom()"
            />
            <span class="errtxt" v-if="phoneNumberError">{{ phoneNumberError }}</span>
        </div>
        <div class="pay">
          <span class="payid">{{ detailsObj.whatsAppMessage }}</span>
          <input class="pay-ipt" v-model="whatsApp" type="number" 
          :class="whatsAppError?'errBorder':''"
          @focus="showBlockBottom"
            @blur="hideBlockBottom();validateWhatsApp()"/>
          <span class="errtxt" v-if="whatsAppError">{{
            $t("withdrawalLogin.Whatsapp")
          }}</span>
          <div class="pay-txt">{{ detailsObj.whatsAppTip }}</div> 
          <!-- <div class="pay-txt">{{ detailsObj.pnotherTip }}</div> -->
        </div>
        <div class="gPayBtn" @click="gPaySubmit">{{ $t('withdrawalLogin.Confirm') }}</div>
        <van-overlay :show="loadingShow">
          <van-loading size="50px" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);"/>
        </van-overlay>
    </div>
</template>
<script>
import axios from "axios";
import { Toast } from "vant";
export default {
  name: "indonesia",
  data() {
    return {
        showBlock: false,
        fullName:'',
        fullNameError:'',
        phoneNumber:'',
        phoneNumberError:'',
        whatsApp:'',
        whatsAppError:'',
        cardNumber:'',
        cardNumberError:'', 
        // 银行列表
        sabankList: [],
        menuFlag: 0,
        bankName:'请选择',
        bankId:'',
        banName:'',
        itemId:'',
        detailsNewObj:{},
        detailsObj:{},
        loadingShow: false
    }
  },
  computed: {
    // 计算属性用于实时过滤数组
    filteredBankList() {
      const query = this.banName.toLowerCase();
      if (!query) {
        return this.sabankList; // 如果没有查询，则返回所有项
      }
      return this.sabankList.filter(item =>
        item.name.toLowerCase().includes(query)
      );
    }
  },
  created(){
    let data = JSON.parse(localStorage.getItem("data"));
    this.language = data.lang || navigator.language;
    this.uid = data.uid || data.userId;
    this.deviceId = data.deviceId || ids
    this.token = data.token;
    let newobj = JSON.parse(this.$route.query.newobj);
    this.detailsNewObj = newobj;
    let obj = JSON.parse(this.$route.query.obj);
    this.detailsObj = obj;
    this.itemId = this.$route.query.id;
    this.getBanList();
    this.getLoaclStorage();
  },
  methods:{
    // 修改选择银行
    changeBank(item){
      this.bankName = item.name;
      this.bankId = item.code;
    },
    // 展开银行列表
    changeMenuFlag(type){
      this.menuFlag = type;
    }, 
    // 请求银行列表
    getBanList(){
      axios
        .get(
          this.$serviceIp +
            `api/trade/card/tx/initForWeb?token=${this.token}&uid=${this.uid}&id=${JSON.parse(this.$route.query.id)}`,{
              headers: {
                'deviceId': this.deviceId
              }
            }
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.sabankList = response.data.data.sabankList;
          } else {
            Toast(response.data.message || this.$t("transfer.error"));
          }
        });
    },  
    // 判断对象是否所有字段都已填写
    isAllFilled(obj) {
      return Object.values(obj).every(value => {
        if (value === null || value === undefined) return false;
        if (typeof value === 'string' && value.trim() === '') return false;
        if (Array.isArray(value) && value.length === 0) return false;
        if (typeof value === 'object' && value.constructor === Object && Object.keys(value).length === 0) return false;
        return true;
      });
    },
     gPaySubmit(){
      let that = this;
      let paramsObj = {
        amount: this.detailsNewObj.num,
        account: this.fullName,
        account_bank_code: this.bankId,
        whatsApp:this.whatsApp
      }
      if(this.itemId == 15){
        paramsObj.account_number = this.cardNumber
      }else{
        paramsObj.account_phone = this.phoneNumber
      }
      // 判断对象是否所有字段都已填写
      if(!this.isAllFilled(paramsObj)) return;
      axios({
        url: that.$serviceIp + `api/trade/card/tx/applyForWeb`,
        method: "post",
          headers: {
            'deviceId': that.deviceId
          },
        data: {
          cid: that.detailsNewObj.id + "",
          params: paramsObj,
        },
        params: { token: that.token, uid: that.uid },
      }).then((res) => {
        if (res.data.code == 200) {
          this.$emit('changeChangeMate');
          this.setLoaclStorage();
        } else {
          Toast(res.data.message || this.$t("transfer.error"));
        }
        this.loadingShow = false
      });
    }, 
    setLoaclStorage(){
      // itemId对应体现渠道的id
      localStorage.setItem("fullName", this.fullName);
      localStorage.setItem("whatsApp", this.whatsApp);
      if(this.itemId == 15){
        localStorage.setItem("cardNumber", this.cardNumber);
      }else{
        localStorage.setItem("phoneNumber", this.phoneNumber);
      }
    },
    getLoaclStorage(){
      // itemId对应体现渠道的id
     this.fullName = localStorage.getItem("fullName") || "";
     this.whatsApp = localStorage.getItem("whatsApp") || "";
      if(this.itemId == 15){
        this.cardNumber = localStorage.getItem("cardNumber") || "";
      }else{
        this.phoneNumber = localStorage.getItem("phoneNumber") || "";
      }
    },
    // 判断是否包含 Emoji 的正则（覆盖大部分常见 Emoji）
    containsEmoji(str) {
      const emojiRegex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935]|[\u2190-\u21ff])/;
      return emojiRegex.test(str);
    },
    validatePhoneNumber(){
      const value = this.phoneNumber.trim();
      // 1. 检查是否为空
      if (!value) {
        this.phoneNumberError = this.detailsObj.bankCardNumber;
        return false;
      }
      // 2. 检查是否全为数字
      if (!/^\d+$/.test(value)) {
        this.phoneNumberError = this.detailsObj.bankCardNumber + this.detailsObj.bankCardNumberInfo;
        return false;
      }
      // 3. 检查长度：最大 30 位
      if (value.length > 30) {
        this.phoneNumberError = this.detailsObj.bankCardNumber;
        return false;
      }
      // 校验通过
      this.phoneNumberError = '';
      return true;
    },  
    // 失去焦点时校验
    validateName(type) {
      const value = this.fullName.trim();
      // 1. 非空校验
      if (value === '') {
        this.fullNameError = this.detailsObj.pnidMessage;
        return false;
      }
      // 2. 长度校验
      if (value.length < 1 || value.length > 100) {
        this.fullNameError = this.detailsObj.pnidMessage;
        return false;
      }
      // 3. Emoji 校验
      if (this.containsEmoji(value)) {
        this.fullNameError = this.detailsObj.pnidMessage;
        return false;
      }
      // ✅ 4. 英文字符校验（只允许字母、空格、连字符、撇号）
      const englishOnlyRegex = /^[a-zA-Z\s\-']+$/;
      if (!englishOnlyRegex.test(value)) {
        this.fullNameError = this.detailsObj.pnidMessage;
        return false;
      }

      // 校验通过，清空错误
      this.fullNameError = '';
      return true;
    },
    // 底部增加方块站位
    showBlockBottom(){
      this.showBlock = true;
      this.$nextTick(()=>{
        window.scrollTo(0, this.$refs.fr_bel.offsetHeight / 2);
      })
    },
    // 底部方块隐藏
    hideBlockBottom(){
      this.showBlock = false;
    },
    validateWhatsApp() {
      const value = this.whatsApp.trim();
      // 1. 检查是否为空
      if (!value) {
        this.whatsAppError = this.detailsObj.whatsAppMessage;
        return false;
      }
      // 2. 检查是否全为数字
      if (!/^\d+$/.test(value)) {
        this.whatsAppError = this.detailsObj.bankCardNumberInfo;
        return false;
      }
      // 3. 检查长度：最大 30 位
      if (value.length > 30) {
        this.whatsAppError = this.detailsObj.whatsAppMessage;
        return false;
      }
      // 校验通过
      this.whatsAppError = '';
      return true;
    },
    validateRib(){
      const value = this.cardNumber.trim();
      // 1. 检查是否为空
      if (!value) {
        this.cardNumberError = this.detailsObj.bankCardNumber;
        return false;
      }
      // 2. 检查是否全为数字
      if (!/^\d+$/.test(value)) {
        this.cardNumberError = this.detailsObj.bankCardNumberInfo;
        return false;
      }
      // 校验通过
      this.cardNumberError = '';
      return true;
    }
  }
}
</script>
<style scoped>

html[lang="ar"] .gPayBox{
  direction: rtl;
} 
html[lang="ar"] .gPayLabel input{
  padding-right: 28px;
}
html[lang="ar"] .gPayLabel .selectInput{
  padding-right: 28px;
}

html[lang="ar"] .searchBank::before{
  left: auto;
  right: 24px;
}
.gPayLabel{
  margin-top: 48px;
  position: relative;
}
.gPayLabel p::after{
  display: inline-block;
  content: '';
  width: 10px;
  height: 11px;
  background: url('../../assets/h5/*.png') no-repeat;
  background-size: 100% 100%;
  vertical-align: top;
  margin-left: 3px;
}
.gPayLabel>div:not(.downMenu){
  height: 94px;
}

.downMenu{
  width: 100%;
  max-height: 632px!important;
  min-height: 200px!important;
  background: #fff;
  border-radius: 20px;
  padding: 28px 28px 0;
  box-sizing: border-box;
  position: absolute;
  z-index: 1;
  overflow: auto;
  top: 150px;
  left: 0;
  box-shadow: 
    0px 0px 10px 2px rgba(0, 0, 0, 0.08); /* 外部扩散的四周阴影 */
}
.downMenut {
  scrollbar-width: none; /* 针对Firefox */
  -ms-overflow-style: none; /* 针对Internet Explorer 和 Edge */
}

.downMenu::-webkit-scrollbar {
  display: none; /* 针对Webkit浏览器（如Chrome和Safari） */
}
.downMenu p{
  font-size: 26px;
  line-height: 88px;
  height: 88px;
  border-bottom: 1px solid #eee;
  font-weight: 500;
  color: #262427;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.downMenu p::after{
  display: none;
}
.gPayLabel input{
  width: 100%;
  border: 1px solid #262427;
  border-radius: 28px;
  height: 92px;
  padding-left: 28px;
  font-size: 26px;
  line-height: 92px;
  color: #000000;
  box-sizing: border-box;
  vertical-align: top;
  background: transparent;
}
.gPayLabel input::placeholder { /* 标准语法 */
  color: #AFA9B4;
  opacity: 1; /* 确保 Firefox 和其他浏览器一致 */
}
.gPayLabel .selectInput{
  width: 100%;
  border: 1px solid #262427;
  border-radius: 28px;
  height: 92px;
  padding-left: 28px;
  font-size: 26px;
  line-height: 92px;
  box-sizing: border-box;
  color: #AFA9B4;
  position: relative;
}
.selectInput i{
  position: absolute;
  width: 32px;
  height: 32px;
  background: url('../../assets/h5/right.png') no-repeat;
  background-size: 100% 100%;
  top: 30px;
  right: 28px;
}
.activeSelect{
  color: #000000!important;
}

.searchBank{
  height: 76px;
  position: relative;
}
.searchBank input{
  width: 528px;
  height: 76px;
  border: none;
  border-radius: 24px;
  background: #F5F6F8;
  padding-left: 70px;
  box-sizing: border-box;
  vertical-align: top;
}
.searchBank:before{
  position: absolute;
  top: 22px;
  left: 24px;
  content:'';
  width: 32px;
  height: 32px;
  background: url('../../assets/h5/searchIcon.png') no-repeat;
  background-size: 100% 100%;
}




.gPayBtn{
  width: 422px;
  height: 92px;
  border-radius: 46px;
  text-align: center;
  font-size: 32px;
  line-height: 92px;
  color: #AFA9B4;
  background: #DFD9E3;
  color: #ffffff;
  background: #4D70FF;
  margin: 0 auto 14px;
}
.errBorder{
  border-color: #FF4365!important;
}
.goTop{
  height: 100vh;
  overflow-y: auto;
  /* transform: translateY(-5rem); */
}
input::placeholder {
  color: #ccc;
  opacity: 1;
}
.pay {
  width: 5.9rem;
  display: flex;
  flex-direction: column;
  margin-top: 0.4rem;
  margin: 0.4rem auto;
}

.payid {
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 17px;
  color: #000000;
}
.payid::after{
  content: '*';
  color: #FF4365;
}
.pay-ipt {
  width: 5.9rem;
  height: 0.82rem;
  font-style: normal;
  font-weight: 400;
  font-size: 0.27rem;
  line-height: 0.82rem;
  color: #000000;
  /* background: #f3f3f5; */
  border-radius: 12px;
  border: none;
  padding-left: 0.27rem;
  padding-right: 0.27rem;
  box-sizing: border-box;
  margin-top: 0.2rem;
  border: 1px solid #CECAD1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 阴影效果 */
}
.pay-ipt-box{
    height: 82px;
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
}
.nameBox .pay-ipt{
  margin-top: 0;
  vertical-align: top;
}
.pay-txt {
  height: 0.58rem;
  color: #acadbc;
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.29rem;
  margin-top: 0.2rem;
}
.errtxt {
  font-size: 0.24rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.29rem;
  color: #FF4365;
  margin-top: 0.1rem;
}
</style>